import * as Yup from 'yup';
import type { TypeOf } from 'yup';

export type ContactFormData = TypeOf<typeof contactFormValidationSchema>;

export const contactFormValidationSchema = Yup.object({
  form_id: Yup.string().required('Form ID is required'),
  first_name: Yup.string().required('First name is required'),
  last_name: Yup.string().required('Last name is required'),
  user_email: Yup.string()
    .email('Invalid email address')
    .required('Email address is required'),
  message: Yup.string()
    .max(5000, 'Message is too Long'),
  accept_legal: Yup.boolean()
    .required('Privacy policy and Terms of Use consent is required')
    .oneOf([true], 'Privacy Policy and Terms of Use consent is required'),
});
